/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/LoadingCard.jsx
 */

import React, { Component } from 'react';
import loadingGif from '../assets/loading.gif';

class LoadingCard extends Component {
  render() {
    const { data, dispatch } = this.props;
    if (!data.details) {
      data.details = [];
    }
    data.createCardFunction(dispatch);
    return (
      <div className="Section">
        <div className="Card">
          <div className="SectionTitle">
            <div>
              <h1>{data.type}</h1>
            </div>
          </div>
          <div className="ResultsSection">
            <div className="DeliveryResultsSection">
              <img src={loadingGif} alt="" />
              <br />
              <h2>Loading</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingCard;
